import React from "react";
import PropTypes from "prop-types";

const GuestAdvocateAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 0H75.6C75.6 8.4 84 8.4 84 8.4V42V75.6C84 75.6 75.6 75.6 75.6 84H42H8.4C8.4 75.6 0 75.6 0 75.6V42C0 42 5.47826e-05 18.9002 0 8.4C8.4 8.40022 8.4 0 8.4 0H42Z"
        fill={fill}
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="84"
        height="84"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84 0H42H0V28.35H84V0ZM84 55.65H42H0V84H84V55.65Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25 13.65V70.35C5.25 70.35 13.65 70.35 13.65 78.75H70.35C70.35 70.35 78.75 70.35 78.75 70.35V13.65C70.35 13.65 70.35 5.25 70.35 5.25H13.65C13.65 13.65 5.25 13.65 5.25 13.65ZM16.4458 8.4C16.1352 9.69792 15.6285 10.8485 14.9585 11.8536C13.8019 13.5884 12.2824 14.7056 10.8587 15.4174C9.99932 15.8471 9.15407 16.1402 8.4 16.3411V67.6589C9.15407 67.8598 9.99932 68.1529 10.8587 68.5826C12.2824 69.2944 13.8019 70.4116 14.9585 72.1464C15.6285 73.1515 16.1352 74.3021 16.4458 75.6H67.5542C67.8648 74.3021 68.3715 73.1515 69.0415 72.1464C70.1981 70.4116 71.7176 69.2944 73.1413 68.5826C74.0007 68.1529 74.8459 67.8598 75.6 67.6589V16.4458C74.3021 16.1352 73.1515 15.6285 72.1464 14.9585C70.4116 13.8019 69.2944 12.2824 68.5826 10.8587C68.1529 9.99932 67.8598 9.15407 67.6589 8.4H16.4458Z"
          fill="white"
        />
      </g>
      <circle cx="77.6996" cy="35.7" r="2.1" fill="white" />
      <ellipse cx="77.6996" cy="48.3" rx="2.1" ry="2.1" fill="white" />
      <ellipse cx="6.3002" cy="35.7" rx="2.1" ry="2.1" fill="white" />
      <ellipse cx="6.3" cy="31.5" rx="1.05" ry="1.05" fill="white" />
      <ellipse cx="6.3" cy="52.5" rx="1.05" ry="1.05" fill="white" />
      <circle cx="77.6994" cy="31.5" r="1.05" fill="white" />
      <circle cx="77.6994" cy="52.5" r="1.05" fill="white" />
      <ellipse cx="6.3002" cy="48.3" rx="2.1" ry="2.1" fill="white" />
      <path
        d="M6.2998 36.75L10.2373 41.8306L6.2998 47.25L2.3623 41.8306L6.2998 36.75Z"
        fill="white"
      />
      <path
        d="M77.7002 36.75L81.6377 41.8306L77.7002 47.25L73.7627 41.8306L77.7002 36.75Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4874 59.264C35.4874 59.264 36.2903 60.7238 37.9391 60.5289C39.5878 60.334 41.5592 59.4538 42.6907 58.2959C43.8221 57.138 43.0463 55.8038 43.0463 55.8038C43.0463 55.8038 39.9526 49.8286 38.6684 47.2875C38.9434 47.2435 39.2969 47.1672 39.7272 47.0742C42.105 46.5607 46.8311 45.54 53.6569 46.6636C66.804 48.8275 52.33 17.1123 45.2307 25.3835C40.0754 31.3899 26.9389 39.595 26.9389 39.595C26.9389 39.595 25.2617 40.9634 26.155 42.864L23.7506 45.1536L24.8673 47.5293L28.1652 47.1403C28.8351 48.5655 30.8644 49.1803 31.8468 48.7185L35.4874 59.264ZM50.4255 27.1588C54.7108 30.7235 58.3589 38.9717 57.216 42.9901C56.0731 47.0085 51.0504 42.7639 49.8441 40.1977C50.6881 39.2417 52.579 36.8238 52.579 36.8238C53.57 35.7779 51.9929 31.8784 50.3456 32.0725C50.3456 32.0725 47.4135 32.7672 46.3623 32.7857C44.7988 29.4595 46.1402 23.594 50.4255 27.1588Z"
        fill="white"
      />
    </svg>
  );
};

GuestAdvocateAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

GuestAdvocateAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default GuestAdvocateAwardIcon;
